<div class="w-100 mb-4" style="height: 450px;">
  <ngx-charts-bar-vertical-2d [results]="chart" [xAxis]="true" [yAxis]="true" [legend]="true" [legendPosition]="'right'"
    [roundDomains]="false" [showDataLabel]="true" [scheme]="colorScheme" legendTitle=""></ngx-charts-bar-vertical-2d>
</div>
